export const AZ_TASK_MANAGER_API = "https://api.taskmanager.knowlys.com/api";
export const AZ_TASK_MANAGER_API_KEY = "x-functions-key";
export const AZ_TASK_MANAGER_API_VALUE = "abcdef";
const header = {};
header[AZ_TASK_MANAGER_API_KEY] = AZ_TASK_MANAGER_API_VALUE;
export const AZ_TASK_MANAGER_HEADERS = { ...header };
// /api/user ? tenant_id = 2 & active=true
